import {
  Create,
  CreateContextProvider,
  SimpleForm,
  TextInput,
  useCreate,
  useCreateController,
  SelectInput,
  ReferenceInput,
  required,
  DateInput,
  NumberInput,
  AutocompleteInput,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useNavigate } from "react-router-dom";
import { validateCompetencia } from "./transactions-util";
import { dateOnlyProps } from "../../util/dateOnly";

export const TransactionsCreate = (props: any) => {
  const controller: any = useCreateController({
    resource: "transactions/crud",
  });
  const history = useNavigate();

  const handleCreateSuccess: any = () => {
    history("/#/transactions/crud");
  };

  const handleCreate = useCreate(
    "transactions/crud",
    {
      data: controller.record,
    },
    {
      onSuccess: handleCreateSuccess,
      onError: (error) => {
        console.error("Error: ", error);
      },
    }
  );

  const filterToQuery = (searchText: any) => ({
    mailName: `${searchText}`,
  });
  const optionRenderer = (choice: any) =>
    `${choice.fullName} ${choice.cpf ? "- CPF: " + choice.cpf : ""} 
    ${
      choice.registrationNumber
        ? " - Matrícula: " + choice.registrationNumber
        : ""
    }${
      choice.registrationNumberDigit ? "-" + choice.registrationNumberDigit : ""
    }`;

  return (
    <CreateContextProvider value={controller}>
      {/* <Create
        redirect="list"
        sx={
          // remove background color
          { backgroundColor: "transparent" }
        }
      > */}
      <PageTopBreadcrumb
        title="Transações"
        firstPath="/#/transactions/crud"
        secondTitle="Novo"
      />
      <Create
        redirect="list"
        sx={{
          width: "100%",
          marginBottom: 3,
        }}
      >
        <SimpleForm>
          <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
            <CardHeader title="Criar" />
            <CardContent>
              <Grid container spacing={0.5}>
                <Grid item xs={12} lg={12}>
                  {/* required remove a opção vazia sem rótulo do topo */}
                  <SelectInput
                    source="type"
                    label="Tipo"
                    choices={[
                      { id: "INCOME", name: "Receita" },
                      { id: "EXPENSE", name: "Despesa" },
                    ]}
                    defaultValue={"INCOME"}
                    validate={required()}
                    fullWidth
                    helperText={false}
                  />
                  <TextInput
                    label="Método de Pagamento"
                    source="paymentMethod"
                    fullWidth
                    helperText={false}
                  />
                  <TextInput
                    label="Competência"
                    source="sCompetencia"
                    fullWidth
                    validate={validateCompetencia}
                    helperText={false}
                  />
                  <DateInput
                    label="Data Referência"
                    source="referenceDate"
                    {...dateOnlyProps}
                    fullWidth
                    helperText={false}
                  />
                  <NumberInput
                    source="value"
                    label="Valor"
                    fullWidth
                    helperText={"Use pontos para decimais"}
                  />
                  {/* <TextInput source="id_Receita" fullWidth helperText={false} /> */}
                  <ReferenceInput
                    source="id_Receita"
                    reference="transaction-categories/crud"
                  >
                    <AutocompleteInput
                      label="Categoria"
                      optionText="name"
                      optionValue="id"
                      fullWidth
                      helperText={false}
                    />
                  </ReferenceInput>
                  {/* <ReferenceInput source="memberId" reference="users/crud">
                  <AutocompleteInput
                    label="Sócio"
                    optionText="fullName"
                    optionValue="id"
                    fullWidth
                    helperText={false}
                  />
                </ReferenceInput> */}
                  <ReferenceInput
                    source="memberId"
                    reference="users/crud"
                    perPage={10}
                    fullWidth
                    // A chave certa é mailName (o filterToQuery gera ela);
                    // "name" nunca existe no filtro
                    enableGetChoices={({ mailName }) =>
                      Boolean(mailName && String(mailName).trim().length >= 2)
                    }
                    alwaysOn
                  >
                    <AutocompleteInput
                      label="Sócio (nome/e-mail/CPF)"
                      optionText={optionRenderer}
                      optionValue="id"
                      fullWidth
                      filterToQuery={filterToQuery}
                      helperText={false}
                    />
                  </ReferenceInput>
                  <TextInput
                    source="memo"
                    fullWidth
                    multiline
                    label="Observações"
                    helperText={false}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </SimpleForm>
      </Create>
      {/* </Create> */}
    </CreateContextProvider>
  );
};
